@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;
@use '../../styling/form-controls.scss' as *;
@use '../../styling/buttons.scss' as *;

.Combobox {
  position: relative;
  display: inline-block;
  min-width: $dropdown-button-min-width;
  width: 100%;
  height: $button-height;

  [type='checkbox'] {
    // Basically hide the default checkbox
    appearance: none;
    position: absolute;

    // Use it as a placeholder for the indicator
    outline: none;
    height: 100%;
    width: 100%;
    margin: 0;
    z-index: -1;

    &:focus {
      outline: none;
    }
  }

  .dropdownWrapper {
    @extend %font-family-primary;

    position: absolute;
    top: 41px; // needs 35px to move dropdown menu to be exactly below highlighted button
    left: 0;
    border-radius: 6px;
    background-color: $theme-dropdown-background-color;
    color: $theme-color-dropdown;
    width: 400px;
    max-height: 450px;
    z-index: 60;
    box-sizing: border-box;
    border: 1px solid $theme-color-dropdown-border-color;
    box-shadow: 0 4px 16px 0 $color-dropdown-box-shadow;

    .maximumListWrapperStyle {
      display: flex;
      padding: 8px 16px;
      justify-content: center;
      text-align: center;
    }

    :focus-visible {
      outline: none;
    }

    .searchWrapper {
      display: block;
      padding: 10px 16px 0 16px;
    }

    .clearSection {
      display: flex;
      padding: 8px 12px;
      justify-content: flex-end;
      border-top: 1px solid $theme-color-info-alert-border;

      &.justifySpaceBetween {
        justify-content: space-between;
      }

      button {
        padding: 0;
      }

      .clearWrapper {
        display: flex;
        padding: 7px 16px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        height: 18px;
        width: 65px;

        svg {
          color: $theme-filter-icon-color;
        }
      }
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 10px 0;
      font-size: $font-size-normal;
      max-height: 330px;
      overflow-y: auto;
      font-weight: normal;
      display: grid;

      .highlighted{
        background: $theme-dropdown-hover-background;
      }

      .groupStyle {
        padding-left: 1em;
      }
    }

    li {
      white-space: nowrap;
      text-align: left;
      cursor: pointer;
      font-weight: $font-weight-semibold;
      padding: 8px 8px 8px 16px;


      &.GroupStyle {
        padding: 8px 8px 8px 32px;
      }

      &[aria-selected='true'] {
        color: $theme-color-text;
        font-weight: $font-weight-semibold;
        background: $theme-dropdown-hover-background;
      }

      .CheckIcon {
        fill: $theme-dropdown-checked-icon-color;
        stroke: $theme-dropdown-checked-icon-color;
      }

      .checkboxStyle {
        display: grid;
        grid-auto-flow: column;
        justify-content: space-between;
        grid-template-columns: minmax(0, 1fr) 16px;
        align-items: center;
      }

      .textStyle {
        display: flex;
        align-items: center;
        column-gap: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: pre;
      }
    }

    &.Hidden {
      display: none;
    }
  }

  &.Enabled {
    background-color: transparent;
  }

  &.Invalid {
  border-color: $color-primary-red;

  &:hover,
  &:focus-within {
      box-shadow: 0 0 0 3px $hover-shadow-error;
    }
  }

  &.isLeftBondedFilters {
    &:hover,
    &:focus-within {
      box-shadow: -1px -2px 0px 1px var(--hover-focus-shadow),
        -1px 2px 0px 1px var(--hover-focus-shadow),
        -2px 0px 0px 1px var(--hover-focus-shadow);
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }

  &.isRightBondedFilters {
    border-left-width: 0px;

    &:hover,
    &:focus-within {
      box-shadow: 1px -1px 0px 2px var(--hover-focus-shadow),
        1px 1px 0px 2px var(--hover-focus-shadow),
        0px 0px 0px 0px var(--hover-focus-shadow);
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }

  &.FilterComboboxMinMaxWidth {
    max-width: 200px;
    min-width: 64px;
    width: max-content;
  }

  .fullWidthDropdownWrapper {
    @extend .dropdownWrapper;

    width: 100%;
  }

  .GroupStyle {
    padding: 20px 16px 8px;
  }

  .listStyle {
    max-width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding-left: 2em;
  }

  .groupListStyle {
    padding-left: 1em;
  }
}

.ErrorMessage {
  @extend %form-control-invalid-font;

  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  column-gap: 6px;
  padding: 8px 2px;
  font-size: $font-size-normal;
  // error message should be control by developer instead of system generate?
  // word-break: break-all;

  .ErrorIcon {
    align-self: baseline;
    margin-top: 3px;
  }
}

.ComboBoxAutoComplete {
  position: relative;
  display: inline-block;
  min-width: $dropdown-button-min-width;
  width: 100%;

  .Layout {
    @extend %form-control-border;
    @extend %form-control-background;

    display: flex;
    gap: 4px;
    align-items: center;
    padding: 0 12px 0 16px;
    box-sizing: border-box;
    overflow: hidden;

    .ClearBtn {
      display: none;

      button {
        display: flex;
        border-radius: 50%;
        align-items: center;
        background-color: $theme-color-sub-background;
        color: $theme-color-text;
        padding: 3px;
      }
    }

    &:hover {
      box-shadow: 0 0 0 3px $hover-shadow-primary;

      .ClearBtn {
        display: block;
      }
    }

    &:focus-within {
      border-color: $color-primary-purple;
      box-shadow: 0 0 0 3px $hover-shadow-primary;

      .ClearBtn {
        display: block;
      }
    }

    &.Readonly {
      background-color: $theme-color-input-readonly;
      color: $theme-color-readonly-field-text;
      border: 1px solid $theme-color-input-readonly-border;

      input::placeholder {
        color: $theme-placeholder-text;
      }

      &:hover,
      &:focus,
      &:focus-within {
        box-shadow: none;
      }
    }

    &.Disabled {
      background-color: $theme-color-sub-background;
      color: $theme-color-readonly-field-text;

      input {
        color: $theme-color-readonly-field-text;
      }

      input::placeholder {
        color: $theme-placeholder-text;
      }

      &:hover,
      &:focus,
      &:focus-within {
        box-shadow: none;
      }

      .ClearBtn {
        display: none;
      }
    }

    &.Invalid {
      border-color: $color-primary-red;

      &:hover,
      &:focus-within {
        box-shadow: 0 0 0 3px $hover-shadow-error;
      }
    }
  }

  input {
    @extend %form-control-font;

    flex-grow: 1;
    border: none;
    outline: none;
    padding: 0;
    height: $component-height;
    box-sizing: border-box;
    appearance: none;
    width: 100%;
    background-color: transparent;

    &::placeholder {
      color: $theme-placeholder-text;
    }

    &[disabled] {
      cursor: not-allowed;
      pointer-events: none;
      color: $theme-color-sub-text;
      box-shadow: none;
    }

    &[readonly] {
      cursor: not-allowed;
      pointer-events: none;
      box-shadow: none;
      color: $theme-color-readonly-field-text;
    }
  }

  > ul {
    list-style: none;
    padding: 0;
    margin: 0;
    font-size: $font-size-normal;
    max-height: 330px;
    overflow-y: auto;
    font-weight: normal;
    display: grid;

    .groupStyle {
      padding-left: 1em;
    }
  }

  .fullWidthDropdownWrapper {
    @extend %font-family-primary;

    position: absolute;
    top: 65px;
    left: 0;
    padding: 10px 0;
    width: 100%;
    border-radius: 6px;
    background-color: $theme-dropdown-background-color;
    color: $theme-color-dropdown;
    z-index: 60;
    box-sizing: border-box;
    border: 1px solid $theme-color-dropdown-border-color;
    box-shadow: 0 4px 16px 0 $color-dropdown-box-shadow;

    :focus-visible {
      outline: none;
    }

    .searchWrapper {
      display: block;
      padding: 10px 16px 0 16px;
    }

    .clearSection {
      display: flex;
      padding: 8px 12px;
      justify-content: flex-end;
      border-top: 1px solid $theme-color-info-alert-border;

      button {
        padding: 0;
      }

      .clearWrapper {
        display: flex;
        padding: 7px 16px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        height: 18px;
        width: 65px;

        svg {
          color: $theme-filter-icon-color;
        }
      }
    }

    li {
      white-space: nowrap;
      text-align: left;
      cursor: pointer;
      font-weight: $font-weight-semibold;
      padding: 8px 8px 8px 16px;

      &.isSelected {
        padding: 8px 16px;
      }

      &[aria-selected='true'] {
        color: $theme-color-text;
        font-weight: $font-weight-semibold;
        background: $theme-dropdown-hover-background;
      }

      .CheckIcon {
        fill: $theme-dropdown-checked-icon-color;
        stroke: $theme-dropdown-checked-icon-color;
      }

      .checkboxStyle {
        display: grid;
        grid-auto-flow: column;
        justify-content: space-between;
        grid-template-columns: minmax(0, 1fr) 16px;
        align-items: center;
      }

      .textStyle {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    &.Hidden {
      display: none;
    }
  }

  .ErrorMessage {
    @extend %form-control-invalid-font;

    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    column-gap: 6px;
    padding: 1px 2px;
    font-size: $font-size-normal;

    .ErrorIcon {
      align-self: baseline;
      margin-top: 3px;
    }
  }
}
